export { title } from "../../content";

export const intros = [
  {
    text: "For 75 international cities, we researched thousands of properties sold in the last 12 months or currently on the market to find the average price of a three-bedroom property. For each market, we calculated exactly how long it would take you, in months, to recoup the property value based on average rental and Airbnb costs.",
    id: "airbnb-global-intro",
  },
];

export const footnotes = [
  {
    text: (
      <span>
        <sup>1</sup>
        The following cities hold varying regulations in regards to Airbnb,
        meaning that properties can only be rented via the platform for a
        limited period over the course of a year. Some of these regulations can
        be overturned on the decision of local authorities, such as in London
        where written permission from the council will allow owners to rent out
        their property for the whole year. Without this permission, the ROI time
        spans in months for the cities with regulations are as follows:
        Reykjavik, Iceland, 132 months (still 58 months less time than
        traditional rental); Amsterdam, the Netherlands, 522 months (189 months
        longer than traditional rental); London, UK, 768 months (367 months
        longer than traditional rental); San Francisco, USA, 816 months (554
        months longer than traditional rental); Paris, France, 648 months (142
        months longer than traditional rental); Barcelona, 297 months (56 months
        less time than traditional rental). Berlin, Hamburg and Munich do not
        allow the rental of unlicensed properties via Airbnb. New York has a
        minimum rental period of 30 days making short-term rental unavailable
        unless tenant also present.
      </span>
    ),
    id: "airbnb-global-footnote-1",
  },
  {
    text: (
      <span>
        <sup>2</sup>
        We looked at all confirmed sales in the city records for 3-bedroom
        properties within the city limits for the past 6 months. We also used
        data from the World Bank and the HSBC.
      </span>
    ),
    id: "airbnb-global-footnote-2",
  },
  {
    text: (
      <span>
        <sup>3</sup>
        We looked at all available properties with the same specifications as
        those in the sold section available for rent in the past 12 months in
        all major rental platforms and real estate agents within the city. This
        changed from country to city. We looked at data from the Word Bank, HSBC
        Property ROI Index, hundreds of property websites and contacted major
        real estate providers in each city.
      </span>
    ),
    id: "airbnb-global-footnote-3",
  },
  {
    text: (
      <span>
        <sup>4</sup>
        For Airbnb costs we looked at all available Airbnb properties with the
        same specifications as those being sold and rented in each city for a
        period of 12 months. We then looked at the average 12 month price, and
        assumed the property would be rented at an 80% capacity. Cities with
        Airbnb legal restrictions have been indicated in the table.
      </span>
    ),
    id: "airbnb-global-footnote-3",
  },
  {
    text: (
      <span>
        <sup>5</sup>
        The cities listed here have already been legislated to limit the number
        of days or ways in which people can rent their property through services
        like Airbnb. Still the numbers in this Index are based on non-restricted
        data in order to present a hypothetical scenario. If you are interested
        in getting the actual time it would take, then please email us at
        press@nested.com.
      </span>
    ),
    id: "airbnb-global-footnote-4",
  },
  {
    text: (
      <span>
        <sup>6</sup>
        The results for London within the international table and the results
        for London within the London centric tables are different due to the
        methodology used to ensure consistency throughout the international
        tables. Within the international table, findings were based in the main
        3 boroughs of the city, and to keep the International comparison
        accurate the same methodology was used for London (Camden, Islington and
        City of Westminster). Within the London centric table, as all 32
        boroughs were taken into account this affected the overall average
        costs.
      </span>
    ),
    id: "airbnb-global-footnote-5",
  },
];

export const buttons = [
  {
    text: "USD",
    categoryUrl: "/usd",
  },
  {
    text: "EUR",
    categoryUrl: "/eur",
  },
  {
    text: "GBP",
    categoryUrl: "/gbp",
  },
];
